import { render, staticRenderFns } from "./SignaturePriority.vue?vue&type=template&id=42b43ddb&scoped=true&"
import script from "./SignaturePriority.vue?vue&type=script&lang=js&"
export * from "./SignaturePriority.vue?vue&type=script&lang=js&"
import style0 from "./SignaturePriority.vue?vue&type=style&index=0&id=42b43ddb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b43ddb",
  null
  
)

export default component.exports